const headerData = [
    {
      prop: "id",
      label: "序号",
      columnwidth: 50,
    },
    {
      prop: "CusName",
      label: "经销商",
      columnwidth: 532
    },
  ];
  export default headerData;
  